import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import {
  orgOperationDecisionSchema,
  type OrgOpSignableDecision,
} from '@mls-wallet/shared-types';
import denApi from '@/lib/api/denApi';
import type { Signature } from '@/types/signature';

type CreateDisasterRecoverySignatureArg = {
  proposalId: string;
  decision: OrgOpSignableDecision;
};

const fetcher = async (
  _key: string,
  { arg }: { arg: CreateDisasterRecoverySignatureArg }
): Promise<Signature[]> => {
  const body = { decision: orgOperationDecisionSchema.parse(arg.decision) };

  return await denApi.post<Signature[], { decision: OrgOpSignableDecision }>(
    `admin/organization/disaster-recovery-proposals/${encodeURIComponent(
      arg.proposalId
    )}/signatures`,
    body
  );
};

/**
 * Signs (approves or rejects) any disaster recovery proposal type.
 */
export function useDisasterRecoveryProposalSignature(
  swrOptions?: SWRMutationConfiguration<
    Signature[],
    Error,
    string,
    CreateDisasterRecoverySignatureArg
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    Signature[],
    Error,
    string,
    CreateDisasterRecoverySignatureArg
  >(
    'admin/organization/disaster-recovery-proposals/signatures',
    fetcher,
    swrOptions
  );

  return { signProposal: trigger, isLoading: isMutating, error };
}
